import qs from "qs";
import axios from "axios";
import AjaxFormat from "./utils/AjaxFormat";
import JsonBig from "json-bigint";
import { navigateToLogin } from "./utils/navigation";

// 保存原始的 JSON.stringify 方法
const originalStringify = JSON.stringify;

// 覆盖 JSON.stringify 方法
JSON.stringify = function (value, replacer, space) {
  // 自定义的 replacer 函数来处理 BigInt 类型
  const customReplacer = (key, value) => {
    if (typeof value === "bigint") {
      return value.toString(); // 将 BigInt 转换为字符串
    }
    return value;
  };

  // 如果 replacer 已经被提供，则组合自定义的 replacer 和已有的 replacer
  const finalReplacer =
    Array.isArray(replacer) || typeof replacer === "function"
      ? (key, value) => customReplacer(key, replacer.call(this, key, value))
      : customReplacer;

  // 使用原始的 stringify 方法，并应用自定义的 replacer
  return originalStringify.call(this, value, finalReplacer, space);
};

// 返回参数格式化
const axiosFormat = new AjaxFormat();

// 请求参数格式化
const requestAxiosFormat = new AjaxFormat();

// 配置 GET 请求 a=[1,2] ==> a=1,2
axios.defaults.paramsSerializer = (params) =>
  qs.stringify(params, { arrayFormat: "comma" });

axios.defaults.transformResponse = [
  function (data) {
    // 对接收的 data 进行任意转换处理
    if (typeof data === "string") {
      try {
        data = JsonBig({
          storeAsString: true,
          useNativeBigInt: true,
        }).parse(data);
      } catch (e) {
        // 处理解析错误
      }
    }

    return data;
  },
];

/**
 * 统一请求拦截器
 */
axios.interceptors.response.use(
  (res) => {
    if (res.status === 200) {
      const data = res.data || {};
      if (data.success) {
        return Promise.resolve(data);
      } else {
        // 登录态过期 需要跳转到登录界面
        if (
          data &&
          (data.errorCode === "SC-A4010" || data.errorCode === 401000)
        ) {
          navigateToLogin();
        }
        const message =
          data.message || data.errorMsg || data.errMsg || data.errorMessage;
        const error = new Error(message || JSON.stringify(data));
        error.code = data.errorCode;
        error.data = data;
        error.originRes = res;
        error.success = false;
        return Promise.reject(error);
      }
    }

    return Promise.reject(
      new Error(`HTTP Status ${res.status} by: ${res.config.url}`)
    );
  },
  (e) => Promise.reject(e)
);

// /**
//  * 返回数据格式化
//  */
// // 做format
// axios.interceptors.response.use(
//   (res) => {
//     return axiosFormat.format(res);
//   },
//   (e) => Promise.reject(e),
// );

// // extends 格式化 ajax 返回值
// axios.interceptors.format = function (path, format) {
//   return axiosFormat.add(path, format);
// };

/**
 * 请求参数格式化
 * requestConfig 是axios请求对象
 */
axios.interceptors.request.use(
  (requestConfig) => {
    return requestAxiosFormat.format(requestConfig);
  },
  (e) => Promise.reject(e)
);

// extends 格式化 ajax 请求参数
axios.interceptors.requestFormat = function (path, format) {
  return requestAxiosFormat.add(path, format);
};
